import { ActionTypes } from '../constants/Actions-Types';

export const insertDealership = (insertData) => ({
  type: ActionTypes.INSERT_DEALERSHIP,
  payload: insertData,
});
export const getSelectedBadgeType = (type) => ({
  type: 'BADGETYPE',
  payload: type,
});
export const getSelectedAuthClientID = (type) => ({
  type: 'AUTHCLIENTID',
  payload: type,
});
export const getDealershipID = (id) => ({
  type: 'ID',
  payload: id,
});
export const getSelectedLevelKey = (id) => ({
  type: 'KEY',
  payload: id,
});
export const getGuideID = (id) => ({
  type: 'GUIDEID',
  payload: id,
});
export const getJourneyID = (id) => ({
  type: 'JID',
  payload: id,
});
export const getCapstoneID = (id) => ({
  type: 'CID',
  payload: id,
});
export const getCapstoneActivityID = (id) => ({
  type: 'CAID',
  payload: id,
});
export const getMainTabID = (id) => ({
  type: 'mainTabID',
  payload: id,
});
export const getSelectedLevelID = (id) => ({
  type: 'levelID',
  payload: id,
});
export const getJourneyTab = (id) => ({
  type: 'journeyTab',
  payload: id,
});
export const getSelectedRoleID = (id) => ({
  type: 'roleID',
  payload: id,
});

export const getTagList = (id) => ({
  type: 'TAGLIST',
  payload: id,
});
export const getInstructorList = (type, id) => {
  if (type === 'add') {
    return {
      type: 'INSTRLIST',
      payload: id,
    };
  }
  if (type === 'append') {
    return {
      type: 'INSTRLISTAPP',
      payload: id,
    };
  }
  if (type === 'update') {
    return {
      type: 'INSTRLISTUP',
      payload: id,
    };
  }
  return {};
};
export const getGuideInstructorList = (type, id) => {
  if (type === 'add') {
    return {
      type: 'GUIDEINSTRLIST',
      payload: id,
    };
  }
  if (type === 'append') {
    return {
      type: 'GUIDEINSTRLISTAPP',
      payload: id,
    };
  }
  if (type === 'update') {
    return {
      type: 'GUIDEINSTRLISTUP',
      payload: id,
    };
  }
  return {};
};
export const getPubDates = (type, data) => {
  if (type === 'add') {
    return {
      type: 'PUBDATES',
      payload: data,
    };
  }
  if (type === 'append') {
    return {
      type: 'PUBDATESAPP',
      payload: data,
    };
  }
  if (type === 'concat') {
    return {
      type: 'PUBDATESCON',
      payload: data,
    };
  }
  if (type === 'remove') {
    return {
      type: 'PUBDATESREM',
      payload: data,
    };
  }
  return {};
};

export const getRoleList = (type = 'ROLELIST', data = []) => {
  if (type === 'ROLELIST') {
    return {
      type: 'ROLELIST',
      payload: data,
    };
  }
  if (type === 'INC') {
    return {
      type: 'INC_ROLE_COUNT',
      payload: data,
    };
  }
  if (type === 'DEC') {
    return {
      type: 'DEC_ROLE_COUNT',
      payload: data,
    };
  }
  return {};
};

export const getGuideTagList = (id) => ({
  type: 'GUIDETAGLIST',
  payload: id,
});

export const getDealershipList = (type, data) => {
  if (type === 'get') {
    return {
      type: ActionTypes.GET_DEALERSHIPLIST,
      payload: data,
    };
  }
  if (type === 'count') {
    return {
      type: 'ADDEMPCOUNT',
      payload: data,
    };
  }
  return {};
};
export const getDepartmentRoleList = (data) => ({
  type: 'DEPTROLELIST',
  payload: data,
});
export const getCheckedAssignedJourneys = (data) => ({
  type: 'CHECKEDASSIGNEDJOURNEYS',
  payload: data,
});
export const getCheckedAssignedInstr = (data) => ({
  type: 'CHECKEDASSIGNEDINSTR',
  payload: data,
});
export const getMandatoryJourneys = (type, data) => {
  if (type === 'add') {
    return {
      type: 'MANDATORYJOURNEYS',
      payload: data,
    };
  }
  if (type === 'append') {
    return {
      type: 'APP_MANDATORYJOURNEYS',
      payload: data,
    };
  }
  return {
    type: 'REMMANDATORYJOURNEYS',
    payload: data,
  };
};
export const getDealershipAssignedJourneys = (type, data) => {
  if (type === 'checkbox') {
    return {
      type: 'ADD_DEALER_ASSIGNED_JOURNEYS',
      payload: data,
    };
  }
  if (type === 'dateRange') {
    return {
      type: 'DATE_DEALER_ASSIGNED_JOURNEYS',
      payload: data,
    };
  }
  return {
    type: 'DEALER_ASSIGNED_JOURNEYS',
    payload: data,
  };
};

export const getCheckedJourneys = (data) => ({
  type: 'CHECKEDJOURNEYS',
  payload: data,
});

export const getCheckedInstr = (data) => ({
  type: 'CHECKEDINSTR',
  payload: data,
});

export const getDealershipDetails = (data) => ({
  type: ActionTypes.DEALERSHIPDETAILS,
  payload: data,
});

export const getChildrenDealerships = (data) => ({
  type: ActionTypes.CHILDRENDEALERSHIPDETAILS,
  payload: data,
});

export const getCustomGroupsForDealership = (data) => ({
  type: 'GET_CUSTOM_GROUPS_FOR_DEALERSHIP',
  payload: data,
});

export const getRulesForDealership = (data) => ({
  type: 'GET_RULES_FOR_DEALERSHIP',
  payload: data,
});

export const getTagsForDealership = (data) => ({
  type: 'GET_TAGS_FOR_DEALERSHIP',
  payload: data,
});

export const getPlanDetails = (data) => ({
  type: ActionTypes.PLANDETAILS,
  payload: data,
});

export const getSelectedPubDate = (data) => ({
  type: 'SELECTEDPUBDATE',
  payload: data,
});
export const getDoses = (type, data) => {
  if (type === 'add') {
    return {
      type: 'DOSESADD',
      payload: data,
    };
  }
  if (type === 'append') {
    return {
      type: 'DOSESAPP',
      payload: data,
    };
  }
  if (type === 'update') {
    return {
      type: 'DOSESUP',
      payload: data,
    };
  }
  if (type === 'filter') {
    return {
      type: 'DOSESFIL',
      payload: data,
    };
  }
  return {};
};

export const getDoseDetails = (data) => ({
  type: 'DOSEDETAILS',
  payload: data,
});

export const getCapstoneActivityDetails = (data) => ({
  type: 'CAPSTONEACTIVITYDETAILS',
  payload: data,
});

export const getCapstoneActivityList = (type, data) => {
  if (type === 'update') {
    return {
      type: 'CAPSTONEACTIVITYLIST',
      payload: data,
    };
  }
  if (type === 'delete') {
    return {
      type: 'DELCAPSTONEACTIVITYLIST',
      payload: data,
    };
  }
  return {};
};
export const getAssignedJourneys = (data) => ({
  type: 'ASSIGNEDJOURNEYS',
  payload: data,
});
export const getPlanAssignedJourneys = (type, data) => {
  if (type === 'fetch') {
    return {
      type: 'PLANASSIGNEDJOURNEYS',
      payload: data,
    };
  }
  if (type === 'unassign') {
    return {
      type: 'UNASSIGNJPLAN',
      payload: data,
    };
  }
  if (type === 'assign') {
    return {
      type: 'ASSIGNJPLAN',
      payload: data,
    };
  }
  return {};
};

export const getCapstoneDetails = (type, data) => {
  if (type === 'delete') {
    return {
      type: 'DELETECAPSTONE',
      payload: data,
    };
  }
  return {
    type: 'CAPSTONEDETAILS',
    payload: data,
  };
};
export const getAuthClientDetails = (data) => ({
  type: 'AUTHCLIENTDETAILS',
  payload: data,
});
export const getGuideDetails = (data) => ({
  type: 'GUIDEDETAILS',
  payload: data,
});
export const getSelectedDealershipFilters = (data) => ({
  type: 'SELECTEDDEALFILTERS',
  payload: data,
});

export const getLevelDetails = (type, data) => {
  if (type === 'levelDetails') {
    return {
      type: 'levelDetails',
      payload: data,
    };
  }
  if (type === 'addGuides') {
    return {
      type: 'ADDGUIDES',
      payload: data,
    };
  }
  if (type === 'capstoneActCountDec') {
    return {
      type: 'DECCAPSTONEACTCOUNTLEVEL',
      payload: data,
    };
  }
  if (type === 'capstoneActCount') {
    return {
      type: 'UPDATECAPSTONEACTCOUNTLEVEL',
      payload: data,
    };
  }
  if (type === 'delCapstoneActCount') {
    return {
      type: 'DELETECAPSTONEACTCOUNTLEVEL',
      payload: data,
    };
  }
  if (type === 'guideDetails') {
    return {
      type: 'GUIDEDETAILSLEVELS',
      payload: data,
    };
  }
  if (type === 'guideDetailsUpdate') {
    return {
      type: 'GUIDEDETAILSLEVELSUPDATE',
      payload: data,
    };
  }
  if (type === 'guideDetailsdelete') {
    return {
      type: 'GUIDEDETAILSLEVELSDELETE',
      payload: data,
    };
  }
  return {
    type: 'editLevelDetails',
    payload: data,
  };
};
export const getCategoryList = (type, data) => {
  if (type === 'fetch') {
    return {
      type: 'CATLIST',
      payload: data,
    };
  }
  return {};
};
export const getJourneyList = (type, data) => {
  if (type === 'fetch') {
    return {
      type: ActionTypes.GET_JOURNEYLIST,
      payload: data,
    };
  }
  if (type === 'update') {
    return {
      type: 'UPDATEJLIST',
      payload: data,
    };
  }
  return {
    type: 'EDITJLIST',
    payload: data,
  };
};
export const getPlanList = (type, data) => {
  if (type === 'fetch') {
    return {
      type: ActionTypes.GET_PLANLIST,
      payload: data,
    };
  }
  if (type === 'update') {
    return {
      type: 'UPDATEPLIST',
      payload: data,
    };
  }
  if (type === 'planJoruneyCount') {
    return {
      type: 'UPDATEPLISTJCOUNT',
      payload: data,
    };
  }
  if (type === 'update_title') {
    return {
      type: 'UPDATETITLE',
      payload: data,
    };
  }
  return {
    type: 'EDITPLIST',
    payload: data,
  };
};
export const getCollectionList = (type, data, id) => {
  if (type === 'fetch') {
    return {
      type: ActionTypes.GET_COLLECTIONLIST,
      payload: data,
      id,
    };
  }
  if (type === 'update') {
    return {
      type: 'UPDATECLIST',
      payload: data,
    };
  }
  if (type === 'collectionJourneyCount') {
    return {
      type: 'UPDATECLISTJCOUNT',
      payload: data,
    };
  }
  if (type === 'update_title') {
    return {
      type: 'UPDATECOLLECTIONTITLE',
      payload: data,
    };
  }
  if (type === 'update_details') {
    return {
      type: 'UPDATEDETAILS',
      payload: data,
    };
  }
  if (type === 'update_selectedId') {
    return {
      type: 'UPDATEID',
      payload: data,
      id,
    };
  }
  return {
    type: 'EDITCLIST',
    payload: data,
  };
};
export const getEmployeeList = (type, data) => {
  if (type === 'fetch') {
    return {
      type: ActionTypes.GET_EMPLOYEELIST,
      payload: data,
    };
  }
  if (type === 'update') {
    return {
      type: 'UPDATEELIST',
      payload: data,
    };
  }
  return {
    type: 'EDITELIST',
    payload: data,
  };
};
export const getAllBadges = (type, data) => {
  if (type === 'add') {
    return {
      type: 'ADDBADGE',
      payload: data,
    };
  }
  if (type === 'update') {
    return {
      type: 'UPDATEBADGE',
      payload: data,
    };
  }
  if (type === 'append') {
    return {
      type: 'APPENDBADGE',
      payload: data,
    };
  }
  if (type === 'remove') {
    return {
      type: 'REMOVEBADGE',
      payload: data,
    };
  }
  return {};
};
export const getBadgeTypeList = (type, data) => {
  if (type === 'add') {
    return {
      type: 'ADDBADGETYPELIST',
      payload: data,
    };
  }
  if (type === 'IncreaseBadgeCount') {
    return {
      type: 'INCBADGECOUNT',
      payload: data,
    };
  }
  if (type === 'DecreaseBadgeCount') {
    return {
      type: 'DECBADGECOUNT',
      payload: data,
    };
  }
  return {};
};
export const getAuthClientList = (type, data) => {
  if (type === 'add') {
    return {
      type: 'ADDAUTHCLIENTLIST',
      payload: data,
    };
  }
  if (type === 'update') {
    return {
      type: 'UPDATEAUTHCLIENTLIST',
      payload: data,
    };
  }
  if (type === 'append') {
    return {
      type: 'APPENDAUTHCLIENTLIST',
      payload: data,
    };
  }
  return [];
};
export const getJourneyDetails = (type, data) => {
  if (type === 'updateLevelIds') {
    return {
      type: 'UPDATELEVELIDS',
      payload: data,
    };
  }
  if (type === 'updateLevel') {
    return {
      type: 'UPDATELEVEL',
      payload: data,
    };
  }
  if (type === 'appendLevelIds') {
    return {
      type: 'APPENDLEVELIDS',
      payload: data,
    };
  }
  if (type === 'deleteLevelId') {
    return {
      type: 'DELETELEVELIDS',
      payload: data,
    };
  }
  if (type === 'updateJourney') {
    return {
      type: 'UPDATEJOURNEY',
      payload: data,
    };
  }
  if (type === 'ADD_CHECKIN_ID') {
    return {
      type: 'ADD_CHECKIN_ID',
      payload: data,
    };
  }
  return {
    type: ActionTypes.JOURNEYDETAILS,
    payload: data,
  };
};
export const getDepartment = (data) => ({
  type: 'DEPT',
  payload: data,
});
export const getPlanAuth = (type) => ({
  type: 'ADDPLANAUTH',
  payload: type,
});
export const getAddCollectionFilters = (type) => ({
  type: 'ADDCOLLECTIONFILTERS',
  payload: type,
});
export const getCollection = (type, data) => {
  if (type === 'update_journey') {
    return {
      type: 'UPDATECJOURNEY',
      payload: data,
    };
  }
  if (type === 'update_collection') {
    return {
      type: 'UPDATECOLLECTION',
      payload: data,
    };
  }
  if (type === 'ADD_CHECKIN_IDS') {
    return {
      type: 'ADD_CHECKIN_IDS',
      payload: data,
    };
  }
  return {
    type: 'ADDCOLLECTION',
    payload: data,
  };
};
export const getDealershipMenu = (type, data) => {
  if (type === 'inc_emp_count') {
    return {
      type: 'INCEMPCOUNT',
      payload: data,
    };
  }
  if (type === 'dec_emp_count') {
    return {
      type: 'DECEMPCOUNT',
      payload: data,
    };
  }
  if (type === 'add_menu') {
    return {
      type: 'DEALERSHIPMENU',
      payload: data,
    };
  }
  return {
    type: 'DEALERSHIPMENU',
    payload: data,
  };
};

export const getDealershipDepartments = (type, data) => {
  if (type === 'fetch') {
    return {
      type: 'SET_DEALERSHIP_DEPARTMENT_VALUES',
      payload: data,
    };
  }
  return {
    type: 'GET_DEALERSHIP_DEPARTMENT_VALUES',
    payload: data,
  };
};

export const getDepartmentRole = (type, data) => {
  if (type === 'dept_roles') {
    return {
      type: 'DEPT_ROLES',
      payload: data,
    };
  }
  return {
    type: 'CLEAR',
    payload: [],
  };
};
export const getTempChecksDept = (type, data) => {
  if (type === 'add') {
    return {
      type: 'TEMP_DEPT',
      payload: data,
    };
  }
  return {
    type: 'TEMP_DEPT_DES',
    payload: [],
  };
};

export const getTempChecksRoles = (type, data) => {
  if (type === 'add') {
    return {
      type: 'TEMP_ROLES',
      payload: data,
    };
  }
  return {
    type: 'TEMP_ROLES_DES',
    payload: [],
  };
};
export const getSelectedDeptRoles = (type, data) => {
  if (type === 'append') {
    return {
      type: 'APP_SEL_DEPT_ROLES',
      payload: data,
    };
  }
  if (type === 'remove') {
    return {
      type: 'REM_SEL_DEPT_ROLES',
      payload: data,
    };
  }
  if (type === 'clear') {
    return {
      type: 'CLEAR_SEL',
      payload: data,
    };
  }
  return {
    type: 'ADD_SEL',
    payload: data,
  };
};
export const getAllDepartments = (data) => ({
  type: 'ALL_DEPT',
  payload: data,
});
export const setDepartmentEmpCnt = (data) => ({
  type: 'EMP',
  payload: data,
});

export const showProgress = (data) => ({
  type: 'PROGRESS',
  payload: data,
});

export const setDevAccess = (data) => ({
  type: 'DEV_ACCESS',
  payload: data,
});

export const showDevPanel = () => ({
  type: 'DEV_PANEL',
});

export const getDEVTabId = (id) => ({
  type: 'DEV_PANEL_TAB_ID',
  payload: id,
});

export const setCategoryData = (data, id) => ({
  type: 'SET_CATEGORY_LIST',
  payload: data,
  activeTabId: id,
});

export const setCategoryDept = (data, id) => ({
  type: 'SET_CATEGORY_DEPT',
  payload: data,
  activeTabId: id,
});

export const setCategoryDeptCol = (data, id) => ({
  type: 'SET_SELECTED_DEPT_COL',
  payload: data,
  activeTabId: id,
});

export const deleteCategory = (data) => ({
  type: 'REMOVE_CATEGORY_DETAILS',
  payload: data,
});

export const getLeaderboardList = (data) => ({
  type: 'GET_LEADERBOARD_LIST',
  payload: data,
});

export const setLeaderboardId = (id) => ({
  type: 'SET_LEADERBOARD_ID',
  payload: id,
});

export const getLeaderboardOverview = (data) => ({
  type: 'GET_LEADERBOARD_OVERVIEW',
  payload: data,
});

export const deleteLeaderboard = (data) => ({
  type: 'REMOVE_LEADERBOARD_DETAILS',
  payload: data,
});

export const setNetworkPartnerList = (data) => ({
  type: 'SET_NETWORK_PARTNER_LIST',
  payload: data,
});

export const setRnpList = (data) => ({
  type: 'SET_RNP_LIST',
  payload: data,
});

export const setContestData = (data, id) => ({
  type: 'SET_CONTEST_LIST',
  payload: data,
  activeTabId: id,
});

export const getContestDetails = (data) => ({
  type: 'GET_CONTEST_DETAILS',
  payload: data,
});

export const getRnpDetails = (data) => ({
  type: 'GET_RNP_DETAILS',
  payload: data,
});

export const getRnpSelectedType = (data) => ({
  type: 'SET_SELECTED_TYPE',
  payload: data,
});

export const deleteContest = (data) => ({
  type: 'REMOVE_CONTEST_DETAILS',
  payload: data,
});

export const setAdminUsersList = (data, id) => ({
  type: 'SET_ADMIN_USERS_LIST',
  payload: data,
  activeTabId: id,
});

export const setAdminUserDetails = (data) => ({
  type: 'SET_ADMIN_USER_DETAILS',
  payload: data,
});

export const setInappData = (data, id) => ({
  type: 'SET_INAPP_LIST',
  payload: data,
  activeTabId: id,
});

export const setCustomGroupsListData = (data) => ({
  type: 'SET_CUSTOM_GROUP_LIST',
  payload: data,
});

export const setCustomGroupsDetails = (data) => ({
  type: 'SET_CUSTOM_GROUP_DETAILS',
  payload: data,
});

export const getCustomGroupDetails = (data) => ({
  type: 'GET_CUSTOM_GROUP_DETAILS',
  payload: data,
});

export const setRulesListData = (data) => ({
  type: 'SET_RULES_LIST',
  payload: data,
});

export const setRulesDetails = (data) => ({
  type: 'SET_RULES_DETAILS',
  payload: data,
});

export const deleteRule = (data) => ({
  type: 'DELETE_RULE',
  payload: data,
});

export const setRuleJourneyCount = (data) => ({
  type: 'SET_RULE_JOURNEY_COUNT',
  payload: data,
});

export const getRulesDetails = (data) => ({
  type: 'GET_RULES_DETAILS',
  payload: data,
});

export const getInappDetails = (data) => ({
  type: 'GET_INAPP_DETAILS',
  payload: data,
});

export const deleteInapp = (data) => ({
  type: 'REMOVE_INAPP_DETAILS',
  payload: data,
});

export const getCustomDepartment = (type, data) => {
  if (type === 'set') {
    return {
      type: 'SET_CUSTOM_DEPARTMENT',
      payload: data,
    };
  }
  return {
    type: 'GET_CUSTOM_DEPARTMENT',
    payload: data,
  };
};

export const getTopicOfTheMonth = (type, data) => {
  if (
    type === 'SET_DATES_LIST' ||
    type === 'SET_DATE' ||
    type === 'SET_DATE_DATA' ||
    type === 'SET_TOPIC_DATA' ||
    type === 'SET_TOPIC_ID'
  ) {
    return {
      type,
      payload: data,
    };
  }
  return {
    type: 'GET',
    payload: data,
  };
};
export const setPxDashboardSidebarList = (data) => ({
  type: 'SET_PX_USERS',
  payload: data,
});

export const setPxDashboardSelectedUser = (data) => ({
  type: 'SET_PX_USER',
  payload: data,
});

export const setPxDashboardSelectedUserData = (data) => ({
  type: 'SET_PX_USER_DATA',
  payload: data,
});

export const setPxDashboardFilters = (data) => ({
  type: 'SET_PX_FILTERS',
  payload: data,
});

export const clearPxDashboardFilters = (data) => ({
  type: 'CLEAR_PX_FILTERS',
  payload: data,
});

// RockED Curriculum
export const setRockedCurriculumSidebar = (data) => ({
  type: 'SET_ROLES',
  payload: data,
});

export const setRockedCurriculumSelectedRole = (data) => ({
  type: 'SET_ROLE',
  payload: data,
});

export const setRockedCurriculumSelectedTenure = (data) => ({
  type: 'SET_TENURE',
  payload: data,
});

export const setRockedCurriculumTenures = (data) => ({
  type: 'SET_TENURES',
  payload: data,
});

// RockED Fuel
export const setRockedFuelSidebar = (data) => ({
  type: 'SET_CATEGORIES',
  payload: data,
});

export const setRockedFuelSelectedCategory = (data) => ({
  type: 'SET_CATEGORY',
  payload: data,
});

export const setRockedFuelSelectedSubCategory = (data) => ({
  type: 'SET_SUBCATEGORY',
  payload: data,
});

export const setFuels = (data) => ({
  type: 'SET_FUELS',
  payload: data,
});

export const setSelectedFuel = (data) => ({
  type: 'SET_FUEL',
  payload: data,
});

// Topics
export const setTopicsSidebar = (data) => ({
  type: 'SET_TOPICS',
  payload: data,
});

export const setSelectedTopic = (data) => ({
  type: 'SET_TOPIC',
  payload: data,
});

export const setSelectedTopicInfo = (data) => ({
  type: 'SET_TOPIC_INFO',
  payload: data,
});

// Certification
export const setCertSidebar = (data) => ({
  type: 'SET_CERTS',
  payload: data,
});

export const setSelectedCert = (data) => ({
  type: 'SET_CERT',
  payload: data,
});

export const setSelectedCertInfo = (data) => ({
  type: 'SET_CERT_INFO',
  payload: data,
});
export const setSelectedCertInfoEdit = (data) => ({
  type: 'SET_CERT_INFO_EDIT',
  payload: data,
});
export const setSelectedCertInfoStat = (data) => ({
  type: 'SET_CERT_INFO_STAT',
  payload: data,
});

// AI roleplay
export const setExerciseCategories = (data) => ({
  type: 'SET_EXERCISES_CATS',
  payload: data,
});

export const setExerciseCategory = (data) => ({
  type: 'SET_EXERCISE_CAT',
  payload: data,
});

export const setExercise = (data) => ({
  type: 'SET_EXERCISE',
  payload: data,
});

export const setSelectedExercise = (data) => ({
  type: 'SELECTED_EXERCISE',
  payload: data,
});

// QUIZ SERIES
export const getQuizSeriesList = (data) => ({
  type: 'QUIZ_SERIES_LIST',
  payload: data,
});

// QUIZ SERIES
export const getQuizSeriesOverview = (data, id) => ({
  type: 'QUIZ_SERIES_OVERVIEW',
  payload: data,
  id,
});

// QUIZ
export const getQuizDetails = (data, id) => ({
  type: 'QUIZ_DETAILS',
  payload: data,
  id,
});
